import lrPanel from './_src/lrPanel.vue'

lrPanel.install = function(Vue) {
  Vue.component(lrPanel.name, lrPanel)
}

export default lrPanel